"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupCompaniesBlock = void 0;
const react_1 = __importDefault(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const GroupCompaniesBlock = (props) => {
    var _a, _b, _c;
    return react_1.default.createElement("div", Object.assign({ className: 'groupCompaniesBlock', "data-glenabled": (_a = props.data.enableGlossary) === null || _a === void 0 ? void 0 : _a.value }, (((_b = props.data.blockLanguage) === null || _b === void 0 ? void 0 : _b.value) !== '' ? { lang: (_c = props.data.blockLanguage) === null || _c === void 0 ? void 0 : _c.value } : null)),
        react_1.default.createElement("div", { className: 'row align-items-sm-center pt-10 pb-0' },
            react_1.default.createElement("div", { className: 'col-12' },
                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'mainBody' })),
            react_1.default.createElement("div", { className: 'col-12' },
                react_1.default.createElement("div", { className: 'row mx-0 mb-sm-10' },
                    react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.companyLinks, propertyName: "companyLinks", noWrap: true })))));
};
exports.GroupCompaniesBlock = GroupCompaniesBlock;
exports.default = exports.GroupCompaniesBlock;
